import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglesearchconsoleComponent } from './simple-icons-googlesearchconsole.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglesearchconsoleComponent ],
    exports:      [ SimpleIconsGooglesearchconsoleComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglesearchconsoleModule {}
